export default {
  paymentInfo: '/v3/recruit/equipment/payment/info',
  toPay: '/v3/recruit/registration/cost/pay'
}
